// jshint esversion: 8
import rules from './rules';

const ruleFactory = {
  rates: [
    rules.valueRule('A value is required for this type of rate'),
    rules.regexRule(/^\d{0,4}(\.\d{1,2})?$/, 'Rate must have format ###.## or ###')
  ],
  name: [ rules.valueRule('A value is required for Name') ]
};

export default {
  get: name => ruleFactory[name]
};
